"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Given an object and a deep or shallow path, this function will fetch the value
 * eg getObjectValue(someObject, 'location.geo.long') would return the value of the path provided or undefined
 * @param obj
 * @param path
 */
exports.default = (obj, path) => {
    const parts = path.split('.');
    if (Array.isArray(parts)) {
        for (let i = 0; i < parts.length; i++) {
            if (obj && (Object.prototype.hasOwnProperty.call(obj, parts[i]) || obj[parts[i]])) {
                obj = obj[parts[i]];
            }
            else {
                return undefined;
            }
        }
        return obj;
    }
    return undefined;
};
